import { VFC } from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { NotFound as messages } from '../messages';

export const NotFoundFooter: VFC = () => {
  const navigate = useNavigate();
  return (
    <Button className="w-100" type="primary" onClick={() => navigate('/')}>
      <FormattedMessage {...messages.goBack} />
    </Button>
  );
};
